/**
 * The one slug rule: collection, article and industry slugs, and a content asset's slug derived
 * from its name. Canonical copy — Phoenix's `~/utils/string.ts` re-exports it so app callers keep the
 * same auto-imported `slugify` name.
 */
export const slugify = (text: string) => {
  return text
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w-]/g, '') // Remove non-word chars (except hyphens)
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens
};

/**
 * SNAKE_CASE → camelCase (collection-category i18n keys). Canonical copy — Phoenix's
 * `~/utils/string.ts` re-exports it.
 */
export const camelCaseConversion = (value: string) => {
  return value.toLowerCase().replace(/_([a-z])/g, (_, letter: string) => letter.toUpperCase());
};

/**
 * Capitalises the first letter (story-transcript character roles). Canonical copy — Phoenix's
 * `~/utils/string.ts` re-exports it.
 */
export const upperCaseFirstLetter = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};
